import { useEffect } from 'react';
import { useClearRefinements } from 'react-instantsearch';

interface ClearLocationRefinementsProps {
  shouldClear: boolean;
}

export const ClearLocationRefinements = ({
  shouldClear,
}: ClearLocationRefinementsProps) => {
  const { refine, canRefine } = useClearRefinements({
    includedAttributes: [
      'hierarchicalZonas.lvl0',
      'hierarchicalZonas.lvl1',
      'hierarchicalZonas.lvl2',
    ],
  });

  useEffect(() => {
    if (shouldClear && canRefine) {
      refine();
    }
  }, [shouldClear, canRefine, refine]);

  return null; // This component doesn't render anything
};
